import {Badge} from '@mantine/core';
import {Anchor} from 'src/design/atoms/Anchor';
import {Group} from 'src/design/atoms/Group';
import {Paper} from 'src/design/atoms/Paper';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {ThemeIcon} from 'src/design/atoms/ThemeIcon';
import React from 'react';
import {Handle, Position} from '@xyflow/react';
import {getWorkflowStateColor} from 'src/app/workflows/workflowHelpers';
import {nodeTypeConfig, getNodeStyle, NODE_WIDTH, NODE_HEIGHT} from './nexusGraphConfig';
import type {NexusFlowNodeData} from './nexusGraphTypes';

export const EntityNodeCard: React.FC<{data: NexusFlowNodeData}> = React.memo(({data}) => {
  const {nexusNode, isEntryPoint} = data;
  const config = nodeTypeConfig[nexusNode.type];
  const url = config.getUrl(nexusNode);
  const state = nexusNode.state ?? null;
  const subtitle = config.getSubtitle(nexusNode);
  const stateStyle = getNodeStyle(nexusNode.visualState);

  return (
    <>
      <Handle type="target" position={Position.Left} style={{visibility: 'hidden'}} />
      <Paper
        shadow="xs"
        p="xs"
        withBorder
        style={{
          ...stateStyle,
          width: NODE_WIDTH,
          height: NODE_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          ...(isEntryPoint && {boxShadow: '0 0 0 2px var(--mantine-color-blue-5)'}),
        }}>
        <Stack gap={4} style={{width: '100%'}}>
          <Group gap="xs" wrap="nowrap">
            <ThemeIcon size="sm" variant="light" color={config.color}>
              {config.icon}
            </ThemeIcon>
            <Text fw={isEntryPoint ? 700 : 500} size="sm" lineClamp={1}>
              {config.getDisplayName(nexusNode)}
            </Text>
          </Group>
          {state && (
            <Group gap={4} ml={28}>
              <Badge size="xs" variant="light" color={getWorkflowStateColor(state)}>
                {state}
              </Badge>
            </Group>
          )}
          {subtitle && (
            <Text size="xs" c="dimmed" ml={28} lineClamp={1}>
              {subtitle}
            </Text>
          )}
          {url && (
            <Anchor href={url} target="_blank" size="xs" ml={28} onClick={e => e.stopPropagation()}>
              Open {config.label} →
            </Anchor>
          )}
        </Stack>
      </Paper>
      <Handle type="source" position={Position.Right} style={{visibility: 'hidden'}} />
    </>
  );
});
